/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2023. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import { combineReducers } from 'redux';
import { ReduxUtils } from '@spm/core';
import { FETCH_NEXT_PAYMENTS_SUMMARIES, SET_TEST } from './actionTypes';

/**
 * Updates the details in the 'NextPaymentsSummaries' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
var fetchNextPaymentsSummariesReducer = function fetchNextPaymentsSummariesReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  return ReduxUtils.generateReducer(state, action, FETCH_NEXT_PAYMENTS_SUMMARIES);
};

/**
 * Updates the indicator of creation of details in the 'NextPaymentsSummaries' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
var isFetchingFetchNextPaymentsSummariesReducer = function isFetchingFetchNextPaymentsSummariesReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  return ReduxUtils.generateFetchingReducer(state, action, FETCH_NEXT_PAYMENTS_SUMMARIES);
};

/**
 * Updates the post data errors in the store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 */
var fetchNextPaymentsSummariesErrorReducer = function fetchNextPaymentsSummariesErrorReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  return ReduxUtils.generateErrorReducer(state, action, FETCH_NEXT_PAYMENTS_SUMMARIES);
};

/**
 * Updates the store with the new data.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 */
var setTestReducer = function setTestReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  return ReduxUtils.generateReducer(state, action, {
    successAction: SET_TEST
  });
};
var reducers = combineReducers({
  fetchNextPaymentsSummaries: fetchNextPaymentsSummariesReducer,
  isFetchingFetchNextPaymentsSummaries: isFetchingFetchNextPaymentsSummariesReducer,
  fetchNextPaymentsSummariesError: fetchNextPaymentsSummariesErrorReducer,
  Test: setTestReducer
});
export default {
  reducers: reducers
};